import React, { Component, PropTypes } from 'react';
import LeftBarDetail from './left-bar-detail';

class TaxId extends Component {

  render() {
    const { profileToShow, isEditable, editField } = this.props;
    return (
      <div />
    );
  }
}

TaxId.propTypes = {
  profileToShow: PropTypes.object,
  isEditable: PropTypes.bool,
  editField: PropTypes.func,
};

export default TaxId;



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-left-bar/tax-id.jsx